/* eslint-disable react/jsx-no-bind */
import * as React from 'react'
import { ENTER_ESCAPE } from '../../constants/key-maps'
import { RectangleButton } from '../buttons'
import HotKeys from '../hot-keys'
import Loader from '../loader'
import { ModalWrapper } from '../modal-wrapper'
import { H6, TinyText } from '../texts'
import { Styled } from './styled'

class CustomDialogComponent extends React.Component {

  render() {
    const {
      mainText,
      secondaryText,
      onSubmit,
      onReject,
      submitText = 'Delete',
      rejectText = 'Cancel',
      submitButtonMood = 'negative',
      cancelButtonMood,
      width = 370,
      height = 260,
      autoHeight,
      children,
      loaderMode,
    } = this.props
    if (loaderMode) {
      return (
        <Styled.Container containerWidth={width} containerHeight={height}>
          <Loader />
        </Styled.Container>
      )
    }
    const withButtons = onSubmit || onReject;
    return (
      <HotKeys keyMap={ENTER_ESCAPE} handlers={{ escape: onReject, enter: onSubmit }} autofocus={true}>
        <Styled.Container
          containerWidth={width}
          containerHeight={height}
          autoHeight={autoHeight}
        >
          <H6 textAlign="center">{mainText}</H6>
          {secondaryText && <TinyText textAlign="center" font="Light" color="gray">{secondaryText}</TinyText>}
          {children && <Styled.Body>{children}</Styled.Body>}
          {withButtons &&
            <Styled.Buttons>
              {onSubmit &&
                <RectangleButton
                  onClick={onSubmit}
                  text={submitText}
                  height={50}
                  width={125}
                  mood={submitButtonMood}
                />
              }
              {onReject &&
                <RectangleButton
                  onClick={onReject}
                  height={50}
                  width={125}
                  text={rejectText}
                  mood={cancelButtonMood}
                />
              }
            </Styled.Buttons>
          }
        </Styled.Container>
      </HotKeys>
    )
  }
}

export const CustomDialog = (props) => {
  return (
    <ModalWrapper onExit={() => props.onReject()} zIndex={props.zIndex}>
      <CustomDialogComponent {...props} />
    </ModalWrapper>
  )
}
